import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#4F0433",
      contrastText: "#fff",
    },
    secondary: {
      main: "#FF876F",
      contrastText: "#fff",
    },
    accent: {
      main: "#870052",
      contrastText: "#fff",
    },
    background: {
      default: "#fff",
      paper: "#fff",
    },
    text: {
      primary: "#000",
      secondary: "#000",
    },
  },
  components: {
    // MuiAppBar: {
    //   styleOverrides: {
    //     root: {
    //       backgroundColor: "#FF876F",
    //       color: "#fff",
    //     },
    //   },
    // },
    // MuiDrawer: {
    //   styleOverrides: {
    //     paper: {
    //       backgroundColor: "#FF876F",
    //       color: "#fff",
    //     },
    //   },
    // },
    MuiButton: {
      styleOverrides: {
        containedPrimary: {
          backgroundColor: "#870052",
          //   color: "#fff",
          //   "&:hover": {
          //     backgroundColor: "#3b82f6",
          //   },
        },
      },
    },
  },
});

const oldTheme = createTheme({
  palette: {
    primary: {
      main: "#4F0433",
      light: "#870052",
      dark: "#4F0433",
      contrastText: "#fff",
    },
    secondary: {
      main: "#FF876F",
      contrastText: "#000",
    },
    accent: {
      main: "#870052",
    },
  },
});

export default theme;
